export const SearchConf = {
  query: {
    keys: [
      {
        key: 'marina',
        operator: '$containsi',
      },
      {
        key: 'code',
        operator: '$containsi',
      },
      {
        key: 'location',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by Location, Code or Marina',
  initialState: {
    value: '',
  },
};
